export const a11yTicketId = (ticket: wix.events.ticketing.TicketDefinition) => `ticket-${ticket.id}`
export const a11yTicketTypeId = (ticket: wix.events.ticketing.TicketDefinition) => `ticket-type-${ticket.id}`
export const a11yPriceId = (priceId: string) => `price-${priceId}`
export const a11yLabelId = (elementId: string) => `label-${elementId}`
